import type { GraphQLResponse } from 'relay-runtime';

export const QueryPromisesMap = new Map<string, Promise<GraphQLResponse>>();
